import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ComuneDto } from 'src/app/infrastructure/lobby-proxy/DTOs/comune.dto';
import { ItalianRegistryProxyService } from 'src/app/infrastructure/lobby-proxy/lobby-proxy-registry/italian-registry-proxy.service';
import { comuneDtoToMunicipality } from 'src/app/shared/mappings/common-model-dto/municipality-dto.mapping';
import { AutocompleteStrategyBase, SearchSuggestion } from 'src/app/shared/ui-kit/inputs/autocomplete/search-strategy-base';
import { throwIfLobbyErrorCode } from 'src/app/shared/utils/pipes/throwIfLobbyErrorCode.pipe';

@Injectable({
  providedIn: 'root'
})
export class AutocompleteMunicipalitySuggestionService extends AutocompleteStrategyBase {

  constructor(private readonly italianRegistryProxyService: ItalianRegistryProxyService) {
    super()
  }

  override loadSuggestions$(text: string, maxSuggestions: number | undefined, provinceId: number | undefined = undefined): Observable<SearchSuggestion[]> {
    return this.italianRegistryProxyService.searchMunicipality$(
      0, maxSuggestions,
      provinceId,
      undefined,
      text,
      undefined
    ).pipe(
      throwIfLobbyErrorCode,
      map((dto => dto.data as ComuneDto[])),
      map(comuneDtos => comuneDtos.map(dto => comuneDtoToMunicipality(dto))),
      map(municipalities => municipalities.map(municipality => {
        return { id: municipality!.id.toString(), value: municipality!.name + ' (' + municipality!.province.abbreviation + ')' } as SearchSuggestion
      })
      )
    )
  }
}